import { generatePath } from "react-router-dom";

export const path = {
  chargeWallet: {
    route: "/charge-wallet/:id",
    link: (id: string) => generatePath(path.chargeWallet.route, { id }),
  },
};
